import React from "react";
import { fmt, fmtDelta } from "../../lib/game";

// Print-only one-page takeaway sheet. Hidden off-screen until window.print().
export const Handout = ({ session, review }) => {
  const change = session.net_worth - (session.starting_net_worth ?? 0);
  const date = new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" });

  return (
    <div className="handout" data-testid="print-handout">
      <div style={{ borderBottom: "3px solid #10B981", paddingBottom: 16, marginBottom: 24 }}>
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}>
          <h1 style={{ fontFamily: "Outfit, sans-serif", fontSize: 30, fontWeight: 800, margin: 0, color: "#065f46" }}>
            Burgeon
          </h1>
          <span style={{ fontSize: 12, color: "#64748b" }}>{date}</span>
        </div>
        <p style={{ margin: "6px 0 0", fontSize: 14, color: "#475569" }}>
          Financial Literacy Simulation — Personal Takeaway Sheet
        </p>
      </div>

      <h2 style={{ fontFamily: "Outfit, sans-serif", fontSize: 22, margin: "0 0 4px", color: "#0f172a" }}>
        {session.nickname}'s Journey
      </h2>
      {review?.persona && (
        <p style={{ margin: "0 0 16px", fontSize: 14, color: "#059669", fontWeight: 600 }}>{review.persona}</p>
      )}

      <div style={{ display: "flex", gap: 16, margin: "16px 0 24px" }}>
        {[
          { l: "Final Net Worth", v: fmt(session.net_worth) },
          { l: "Change", v: fmtDelta(change) },
          { l: "Cash", v: fmt(session.cash) },
          { l: "Investments", v: fmt(session.investments) },
          { l: "Debts", v: fmt(session.debts) },
        ].map((k) => (
          <div key={k.l} style={{ flex: 1, border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 12px" }}>
            <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: 1, color: "#94a3b8", fontWeight: 700 }}>
              {k.l}
            </div>
            <div style={{ fontFamily: "JetBrains Mono, monospace", fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
              {k.v}
            </div>
          </div>
        ))}
      </div>

      {review?.summary && (
        <p style={{ fontSize: 14, lineHeight: 1.6, color: "#334155", margin: "0 0 18px" }}>{review.summary}</p>
      )}

      {review?.strengths?.length > 0 && (
        <div style={{ marginBottom: 18 }}>
          <h3 style={{ fontFamily: "Outfit, sans-serif", fontSize: 14, textTransform: "uppercase", letterSpacing: 1, color: "#059669", margin: "0 0 8px" }}>
            Your Strengths
          </h3>
          <ul style={{ margin: 0, paddingLeft: 18, color: "#334155", fontSize: 13, lineHeight: 1.6 }}>
            {review.strengths.map((s, i) => <li key={i}>{s}</li>)}
          </ul>
        </div>
      )}

      {review?.reflections?.length > 0 && (
        <div style={{ marginBottom: 18 }}>
          <h3 style={{ fontFamily: "Outfit, sans-serif", fontSize: 14, textTransform: "uppercase", letterSpacing: 1, color: "#1d4ed8", margin: "0 0 8px" }}>
            What You Said vs What You Did
          </h3>
          <ul style={{ margin: 0, paddingLeft: 18, color: "#334155", fontSize: 13, lineHeight: 1.6 }}>
            {review.reflections.map((s, i) => <li key={i}>{s}</li>)}
          </ul>
        </div>
      )}

      {review?.tip && (
        <div style={{ border: "1px solid #fcd34d", background: "#fffbeb", borderRadius: 10, padding: 16 }}>
          <h3 style={{ fontFamily: "Outfit, sans-serif", fontSize: 13, textTransform: "uppercase", letterSpacing: 1, color: "#b45309", margin: "0 0 6px" }}>
            Coach's Tip to Keep
          </h3>
          <p style={{ margin: 0, fontSize: 13, lineHeight: 1.6, color: "#334155" }}>{review.tip}</p>
        </div>
      )}

      <p style={{ marginTop: 28, fontSize: 11, color: "#94a3b8", textAlign: "center" }}>
        Burgeon · A financial literacy simulation for community empowerment
      </p>
    </div>
  );
};
